
// Buttons


/**
 * Start an AJAX button loading
 *
 * @param {object} $button
 *
 * @return {void}
 */
function biro_button_ajax_start( $button ) {

	$button.addClass( 'loading' );

}


/**
 * Finish an AJAX button loading
 *
 * @param {object} $button
 *
 * @return {void}
 */
function biro_button_ajax_finish( $button ) {

	$button.removeClass( 'loading' );

}